import { Tabs, Tab } from '@mui/material'
import { withStyles } from '@mui/styles'

export const StyledTabs = withStyles({
  root: {
    minHeight: 40,
    width: '100%',
    backgroundColor: '#fff',
    boxShadow: 'inset 0 -1px 0 rgba(100,121,143,0.122)',
  },
  indicator: {
    height: 3,
    backgroundColor: 'rgba(0,0,0,0)',
    '& > div': {
      backgroundColor: 'rgba(0,0,0,0.6)',
      borderTopLeftRadius: 3,
      borderTopRightRadius: 3,
      height: 3,
      margin: '0 0px',
    },
  },
})(Tabs);

export const StyledTab = withStyles(theme => ({
  root: {
    opacity: 1,
    '&:hover': {
      backgroundColor: 'rgba(32,33,36,0.059)',
    },
    '&:hover,&:focus': {
      '& $wrapper': {
        color: 'rgba(0,0,0,0.87)',
      },
    },
    minHeight: 40,
    flex: 1,
    maxWidth: 253,
    padding: '6px 16px',
    paddingBottom: 4,
    textTransform: 'none'
  },
  labelIcon: {
    '& $wrapper > *:first-child': {
      marginBottom: 0,
      marginRight: 16,
      fontSize: 20,
    },
  },
  wrapper: {
    color: 'rgba(0,0,0,0.6)',
    flexDirection: 'row',
    //justifyContent: 'flex-start',
    fontSize: 14,
    fontFamily: "'Google Sans', Roboto,RobotoDraft,Helvetica,Arial,sans-serif",
    textTransform: 'initial',
    '& .MuiTabItem-labelGroup': {
      minWidth: 0,
    },
    '& .MuiTabItem-label': {
      display: 'flex',
      alignItems: 'center',
    },
    '& .MuiTabItem-subLabel': {
      color: 'rgba(0,0,0,0.38)',
      fontSize: '0.75rem',
      textAlign: 'left',
      fontWeight: 'normal',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    '& .MuiTabItem-tag': {
      backgroundColor: theme.palette.primary.main,
      color: '#fff',
      fontSize: '0.75rem',
      borderRadius: 2,
      lineHeight: '16px',
      padding: '1px 4px',
      letterSpacing: 0.3,
      marginLeft: 8,
      whiteSpace: 'nowrap',
    },
  },
//   selected: color => ({
//     '& $wrapper': {
//       color: `${color} !important`,
//     },
//   }),
}))(Tab);
